import React, { FC, ReactNode } from 'react';
import { ContentElem } from './Content.styles';

interface IContent {
  children: ReactNode;
  className?: string;
  isUnstyled?: boolean;
}

const Content: FC<IContent> = ({ children, className, isUnstyled = false }) => (
  <ContentElem id="ContentElem" {...{ className, isUnstyled }}>
    {children}
  </ContentElem>
);

export default Content;
